import React, { useEffect, useMemo } from 'react';

import { loadConfiguration, reloadConfiguration } from 'common/actions/ideasConfiguration';
import connect from 'common/core/connect';

type IdeasConfigurationContextValue = {
  loadConfiguration: () => Promise<void>;
  reloadConfiguration: () => Promise<void>;
};

const notReady = () => Promise.reject(new Error('Ideas configuration context is not ready'));
export const IdeasConfigurationContext = React.createContext<IdeasConfigurationContextValue>({
  loadConfiguration: notReady,
  reloadConfiguration: notReady,
});

type ConnectProps = {
  loadConfiguration: () => Promise<void>;
  reloadConfiguration: () => Promise<void>;
};

type OwnProps = {
  children: React.ReactNode;
};

type Props = ConnectProps & OwnProps;

function IdeasConfigurationContainer({ children, loadConfiguration, reloadConfiguration }: Props) {
  useEffect(() => {
    loadConfiguration();
  }, [loadConfiguration]);

  const contextValue = useMemo(
    () => ({
      loadConfiguration,
      reloadConfiguration,
    }),
    [loadConfiguration, reloadConfiguration]
  );
  return (
    <IdeasConfigurationContext.Provider value={contextValue}>
      {children}
    </IdeasConfigurationContext.Provider>
  );
}

export default connect(null, {
  loadConfiguration,
  reloadConfiguration,
})(IdeasConfigurationContainer) as unknown as React.FC<OwnProps>;
